'use client';

/* eslint-disable import/no-unassigned-import */
import { c as _c } from "react/compiler-runtime";
import '../styles/global/_index.scss';
import '../styles/tokens/root-variables.css';
import '../styles/tokens/root-variables-overrides.scss';
import 'react-loading-skeleton/dist/skeleton.css';
/* eslint-enable import/no-unassigned-import */
import classNames from 'classnames';
import { Merriweather, Nunito_Sans } from 'next/font/google';
import { useEffect } from 'react';
import { ErrorPageContentClient } from '@module/mdrt-org/shared/page-content-components/error-page-content/error-page-content-client';
import { logException } from '@shared/utils/helpers/error-logging';
type ErrorPageProps = {
  error: Error & {
    digest?: string;
  };
  reset: () => void;
};
const merriweather = Merriweather({
  subsets: ['latin'],
  variable: '--mdrt-font-families-merriweather',
  weight: ['400', '700', '900']
});
const nunito = Nunito_Sans({
  adjustFontFallback: false,
  display: 'swap',
  fallback: ['Arial', 'sans-serif'],
  subsets: ['latin'],
  variable: '--mdrt-font-families-nunito-sans',
  weight: ['400', '600']
});
const GlobalError = t0 => {
  const $ = _c(7);
  const {
    error,
    reset
  } = t0;
  let t1;
  let t2;
  if ($[0] !== error) {
    t1 = () => {
      logException(error);
    };
    t2 = [error];
    $[0] = error;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = classNames(merriweather.variable, nunito.variable);
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== error.message || $[5] !== reset) {
    t4 = <html lang="en"><body className={t3}><ErrorPageContentClient message={error.message} reset={reset} /></body></html>;
    $[4] = error.message;
    $[5] = reset;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export default GlobalError;